import { useRef } from 'react'
import useMountEffect from './useMountEffect'
import { useAppContext } from '../contexts/AppContext'

export default function useSlideWidthAdjustment() {
  const { rootRef } = useAppContext()
  const parentRef = useRef<HTMLElement>(null)

  useMountEffect(() => {
    if (!rootRef.current) return

    // We have to observe to track whether action cards visible
    const observer = new ResizeObserver(entries => {
      entries.forEach(entry => {
        if (entry.target?.getAttribute('data-role') === 'action-cards-app') {
          const shadowHostParent = (entry.target.getRootNode() as ShadowRoot).host?.parentElement
          const parent = shadowHostParent || entry.target!.parentElement
          const parentClientWidth = parent?.clientWidth || 0

          parentRef.current = parent
          ;(entry.target as HTMLElement).style.setProperty('--slide-width', `${parentClientWidth}px`)
        }
      })
    })

    observer.observe(rootRef.current)
    return () => {
      observer.disconnect()
    }
  })

  useMountEffect(() => {
    if (!rootRef.current) return

    const onResize = () => {
      const parentClientWidth = parentRef.current?.clientWidth || 0
      rootRef.current!.style.setProperty('--slide-width', `${parentClientWidth}px`)
    }

    addEventListener('resize', onResize)
    return () => {
      removeEventListener('resize', onResize)
    }
  })
}
